import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
const locale = require("react-redux-i18n").I18n;
class UserInfo extends Component {
  // constructor(props) {
  //   super(props);
  // }

  logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_login");
    document.cookie = 'utk=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    window.location = this.props.logoutUrl;
    return false;
  };

  render() {
    // const userData = this.props.userData;
    const loginName = this.props.loginName;
    if (loginName) {
      return (
        <div className="box-cart-user">
          <div className="dropdown">
            <button
              className="btn btn-user dropdown-toggle btn-sm"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {loginName}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <div className="dropdown-content">
                <Link to="/register">{locale.t("dataProfile")}</Link>
              </div>
              <a
                className="dropdown-item btn-logout"
                onClick={this.logout}
                href="#logout"
                alt="logout"
              >
                {locale.t("logout")}
              </a>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}
const mapStateToProps = state => ({
  l: state.i18n.locale
});
export default connect(
  mapStateToProps,
  null
)(UserInfo);
